<template>
  <div class="list-group-item animate__animated">

      <div class="row">
        <div class="col-xs-12 col-sm-5 col-md-3 list-group-item-image">
          <div class="list-image">
            <responsive-image v-if="shipData.bilder[0] && getLargestAvailableImage(shipData.bilder[0].filenames, '16x9')"
                              :src="getLargestAvailableImage(shipData.bilder[0].filenames, '16x9')"
                              :src-xs="shipData.bilder.img800_16x9"
                              :src-sm="shipData.bilder.img400_16x9"
                              :src-md="shipData.bilder.img400_16x9"
                              :src-lg="shipData.bilder.img400_16x9"
                              :fixed-aspect-ratio="16/9"
                              img-class="ship-preview-picture img-responsive"/>
          </div>
        </div>
        <div class="col-xs-12 col-sm-7 col-md-5 list-group-item-content">
          <h3>{{ shipData.bezeichnung }}</h3>
          <p>{{ shipData.untertitel }}</p>
        </div>
        <div class="col-xs-12 col-sm-7 col-md-4 list-group-item-button pull-right">
          <a v-bind:href="detailUrl" :target="target">
            <span class="btn btn-primary btn-arrow">Details anzeigen</span>
          </a>
          <a v-bind:href="travelsUrl" :target="target" v-if="showCurrentTravelsLink">
            <span class="btn btn-primary btn-arrow" style="margin-top: 10px;">Aktuelle Reisen</span>
          </a>
        </div>
      </div>
  </div>
</template>
<style></style>
<script type="module">
import HelperMixin from '../mixins/helper-mixin.js'
import ResponsiveImage from './_responsive-image.vue';

export default {
  name: "ship-list-item",
  mixins: [HelperMixin],
  props: {
    shipData: { type: Object, default: false },
    showCurrentTravelsLink: { type: Boolean, default: true }
  },
  data: function () {
    return {
      target: '_self'
    }
  },
  computed: {
    code: function(){
      if(this.shipData){
        return this.shipData.schiffscode;
      }
    },
    detailUrl: function(){
      return '/schiff/' + this.shipData.schiffscode;
    },
    travelsUrl: function(){
      return '/schiff/' + this.shipData.schiffscode + '/aktuelle-reisen';
    }
  },
  methods: {

  },
  created(){

  },
  updated(){

  }
}
</script>
